/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from "ag-grid-react";
import { Row, Col, Modal } from "antd";

import { memo, useContext, useEffect, useMemo, useRef } from "react";
import "ag-grid-enterprise";
import { GlobalContext } from "contexts/GlobalContext";
import "./gridStyles.css";
import { VOL_SURFACE_Control_COLS } from "constants/volSurface";
import { onGridReady } from "helpers/volSurfaceHelper";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { getRowClass, getRowStyle } from "constants/agGridCommonStyle";
import AgGridMonthEstimatesTable from "./AgGridMonthEstimatesTable";
import { getRowId, isTrader } from "helpers/generalHelper";
import useUpdateControlTable from "./hooks/useUpdateControlTable";
import useControlTable from "./hooks/useControlTable";
import {
  CancelButton,
  SecondaryButton,
} from "components/Common/CustomButtons/CustomButtons";
import { createPortal } from "react-dom";
import { storeInLocalStorage } from "helpers/Pricer/Table";

function AgGridControlTable({
  scrollableRef,
  start_date,
  end_date,
  setComparisonSurfaceId,
}) {
  //custom hooks
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);
  const notTrader = !isTrader();
  const gridRef = useRef();

  const {
    isLoading,
    selectedFilters,
    volSurfaceTablesData: rowsData,
    setTableHeight,
    lockedData,
    setLockedData,
  } = useVolSurfaceControlTable();

  const columnDefs = useMemo(
    () => VOL_SURFACE_Control_COLS(notTrader, lockedData?.is_locked),
    [notTrader, lockedData?.is_locked]
  );

  const { onCellEditingStopped, revertCellValue } = useUpdateControlTable({
    scrollableRef,
    gridRef,
  });

  const { isLocking, updateAndTakeOverLock } = useControlTable({
    start_date,
    end_date,
    setComparisonSurfaceId,
  });

  //handle grid height
  useEffect(() => {
    if (rowsData?.length === 0) return;
    const numberOfRowData = rowsData?.length;
    const calculatedHeight = numberOfRowData * 30 + 95;
    setTableHeight(`${calculatedHeight -90}px`);
  }, [rowsData?.length, setTableHeight]);



  const gridOptions = {
    stopEditingWhenGridLosesFocus: false,
  };

  //change color of cell when editing
  gridOptions.onCellEditingStarted = function (event) {
    var editor = event.api.getCellEditorInstances({
      rowIndex: event.rowIndex,
      column: event.column,
    });
    if (editor && editor.length > 0) {
      editor[0].getGui().style.color = dark_Theme ? "white" : "black";
    }
  };

  const onCancelLock = () => {
    if (lockedData?.event) {
      revertCellValue(lockedData?.event);
    }
    setLockedData({
      show_lock_modal: false,
      is_locked: lockedData?.is_locked,
      locked_by: lockedData?.locked_by,
      lock_comparison_surface_dropdown:
        lockedData?.lock_comparison_surface_dropdown,
      event: null,
    });
    storeInLocalStorage("checkPopup", JSON.stringify(false));
  };

  if (isLoading || !selectedFilters?.product_id) return null;

  return (
    <Col
      xs={24}
      xxl={15}
      className={`mainVolSurfaceTable`}
      style={{ margin: "0px", padding: "0px" }}
    >
      <Row justify={"start"} style={{ width: "100%" }}>
        <div
          className={`${
            dark_Theme || false
              ? "pricer-ag-grid__container_dark"
              : "pricer-ag-grid__container"
          }`}
          style={{
            width: "85%",
            padding: "5px 0px 5px 10px",
          }}
        >
          <AgGridReact
            getRowId={getRowId}
            onCellEditingStopped={onCellEditingStopped}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            domLayout="autoHeight"
            headerHeight={30}
            defaultColDef={{
              suppressMenu: true,
            }}
            rowHeight={30}
            rowData={rowsData}
            getRowStyle={(params) => {
              if (params.data.field !== "spread") {
                return {
                  borderTop: "none",
                  borderBottom: "none",
                };
              }
              getRowStyle(params);
            }}
            getRowClass={getRowClass}
            ref={gridRef}
            stopEditingWhenCellsLoseFocus={true}
            suppressMovableColumns={true}
            columnDefs={columnDefs}
            groupDefaultExpanded={1}
            suppressContextMenu
            className={`ag-theme-alpine pricer-ag-grid__table control-table ${
              dark_Theme ? " ag-theme-balham-dark" : "ag-theme-balham"
            }`}
          />
        </div>
        <AgGridMonthEstimatesTable />
      </Row>
      {lockedData?.show_lock_modal &&
        createPortal(
          <Modal
            maskClosable={false}
            className={`${dark_Theme && "ant-modal-dark content_dark"}`}
            title={lockedData?.locked_by}
            style={{
              top: 20,
            }}
            confirmLoading={false}
            open={lockedData?.show_lock_modal}
            onCancel={() => {
              onCancelLock();
            }}
            footer={null}
            centered
          >
            <div className="d-flex flex-column align-items-center">
              <p
                className="text-center"
                style={{ fontSize: "1rem", marginBottom: "30px" }}
              >
                Do you want to take over?
              </p>
              <div className="d-flex justify-content-center gap-3 w-50 align-items-center">
                <CancelButton
                  disabled={isLocking}
                  style={{ width: "50%" }}
                  onClick={() => {
                    onCancelLock();
                  }}
                >
                  No
                </CancelButton>
                <SecondaryButton
                  loading={isLocking}
                  style={{ width: "50%" }}
                  disabled={isLocking}
                  onClick={() => {
                    updateAndTakeOverLock();
                  }}
                >
                  Yes
                </SecondaryButton>
              </div>
            </div>
          </Modal>,
          document.body
        )}
    </Col>
  );
}

export default memo(AgGridControlTable);
